import React from 'react';
import PropTypes from 'prop-types';

import cn from 'classnames';

import styles from './divider.module.scss';

const Divider = ({
  orientation = 'horizontal',
  titlePlacement = 'center',
  children,
  className,
}) => {
  const isVertical = orientation === 'vertical';

  if (isVertical) {
    return <div className={cn(styles.divider, styles['divider-vertical'])} />;
  }

  return (
    <div
      className={cn(
        styles.divider,
        styles['divider-horizontal'],
        children && styles['divider-with-text'],
        children && styles[`divider-with-text-${titlePlacement}`],
        className
      )}
    >
      {children && (
        <>
          <div
            className={cn(
              styles['divider-rail'],
              titlePlacement &&
                titlePlacement !== 'center' &&
                styles[`divider-rail-start`]
            )}
          />
          <span className={styles['divider-inner-text']}>{children}</span>
          <div
            className={cn(
              styles['divider-rail'],
              titlePlacement &&
                titlePlacement !== 'center' &&
                styles[`divider-rail-end`]
            )}
          />
        </>
      )}
    </div>
  );
};

Divider.propTypes = {
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  titlePlacement: PropTypes.oneOf(['left', 'center', 'right']),
  children: PropTypes.node,
  className: PropTypes.string,
};

export default Divider;
